import React, { useState, useEffect, useContext } from "react";
import { AppContext } from "../../AppContextProvider";
import UseraddressJsonStorage from "../../utils/useraddress/useraddressJsonStorage";
import { AvalancheContext } from "../../avalanche/AvalancheProvider";
import { WalletProviderContext } from "../../walletprovider/WalletProvider";
import ProfileJsonStorage from "../../utils/storage/profileJsonStorage";

import {
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBTabs,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsContent,
  MDBTabsPane,
} from "mdb-react-ui-kit";

function UserlistWithOnboarding(props) {
  const context = useContext(AppContext);
  const avalancheContext = useContext(AvalancheContext);
  const useraddressJsonStorage = UseraddressJsonStorage.create(avalancheContext);
  const walletContext = useContext(WalletProviderContext);
  const profileJsonStorage = ProfileJsonStorage.create(avalancheContext, walletContext);

  const getUserList = async () => {
    try {
      const res = await useraddressJsonStorage.getAllUserAddress();
      const array = res.map((k) => {
        return k.address;
      });
      for (let i = 0; i < array.length; i++) {
        loadData(array[i]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const loadData = async (accountname) => {
    try {
      const res = await profileJsonStorage.hasDataForAddress(accountname);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    //getUserList();
  }, [context.getState()?.isRender]);

  return <div className="admin-tabs">{window.location.pathname === "/admin" && <></>}</div>;
}

export default UserlistWithOnboarding;
